import { get, post, put, deleted } from '..';
import routes from './routes';

const CategoryServices = {
  createCategory: async (obj) => {
    const data = await post(routes.createCategory, obj);
    return data;
  },
  getCategories: async (params) => {
    const data = await get(routes.getCategories, params);
    return data;
  },
  getCategoryById: async (id) => {
    const data = await get(routes.getCategoryById + id);
    return data;
  },
  updateCategory: async (id, obj) => {
    const data = await put(routes.updateCategory + id, obj);
    return data;
  },
  deleteCategory: async (id) => {
    const data = await deleted(routes.deleteCategory + id);
    return data;
  },
}

export default CategoryServices